import * as React from 'react';

import { Typography, Paper } from '@mui/material';
import { Box } from '@mui/system';

import useGetFlightEventDrafts from '../../core/api/hooks/flight-event/useGetFlightEventDrafts';
import useGetFlightEventSubmissions from '../../core/api/hooks/flight-event/useGetFlightEventSubmissions';
import useDeleteFightEventDraft from '../../core/api/hooks/flight-event/useDeleteFightEventDraft';

import { EventFormStatus, FormMetadata } from '../../core/api/clients';
import { getColor } from '../../core/colors';
import FlightEventDrafts from './FlightEventDrafts';
import FlightEventList from './FlightEventList';
import { useAuthorizedFormData } from '../../core/context/AuthorizedFormDataContext';
import useGetFormMetadata from '../../core/api/hooks/common/useGetFormMetadata';

function FlightEventDraftsAndSubmissions({ pageSize = 25, formMetadata }: { pageSize?: number, formMetadata?: FormMetadata }) {
  if (!formMetadata) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return (<React.Fragment />);
  }
  const { data: authorizedForm } = useGetFormMetadata(formMetadata.componentName ?? '');

  if (!authorizedForm?.isContributor) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return (<React.Fragment />);
  }
  const { metadata } = authorizedForm;
  if (!metadata) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return (<React.Fragment />);
  }

  return (
    <React.Fragment>
      <Box display="flex" flexDirection="column">
        <Typography variant="h6" sx={{ mb: 0, color: getColor(metadata.color)[500], fontWeight: 300 }}>
          Your Drafts
        </Typography>
        <Paper variant="outlined" sx={{ mt: 0, mb: 1 }}>
          <FlightEventDrafts />
        </Paper>
      </Box>
      <Box margin={2} />
      <Box display="flex" flexDirection="column">
        <Typography variant="h6" sx={{ mb: 0, color: getColor(metadata.color)[500], fontWeight: 300 }}>
          Your Submissions
        </Typography>
        <Paper variant="outlined" sx={{ mt: 0, mb: 1 }}>
          <FlightEventList
            statuses={[EventFormStatus.Submitted]}
            isOwner
            pageSize={pageSize}
          />
        </Paper>
      </Box>
    </React.Fragment>
  );
}

export default FlightEventDraftsAndSubmissions;
